let validationClass = function (vm) {
  let validationClass = false
  if (vm.isLoading) {
    validationClass = 'info'
  } else if (vm.isDirty) {
    validationClass = vm.isValid ? 'valid-feedback' : 'invalid-feedback'
  }
  if (validationClass) {
    return validationClass
  } else {
    return false
  }
}

let validationMessage = function (vm) {
  let msgs = {
    loadingMessage: 'Loading...',
    invalidMessage: 'Invalid value!',
    customMessage: false,
    ...vm.options
  }
  if (vm.invalidMessage) {
    msgs.invalidMessage = vm.invalidMessage
  }
  let msg = false
  if (vm.isLoading) {
    msg = msgs.loadingMessage
  } else if (vm.customError && vm.isDirty) {
    msg = vm.customError
  } else if (vm.isDirty && !vm.isValid) {
    msg = msgs.invalidMessage
  }
  return msg
}

let validationIcon = function (vm) {
  let iconClass = false
  if (vm.isValid) {
    iconClass = 'success fa-check'
  } else {
    iconClass = 'error fa-remove'
  }
  if (vm.isLoading) {
    iconClass = 'info fa-circle-o-notch fa-spin'
  }
  if (iconClass && vm.isDirty) {
    return 'fa form-control-feedback form-control-feedback-' + iconClass
  } else {
    return false
  }
}

let formControlValidationClass = function (vm) {
  if (vm.isDirty) {
    if (vm.isValid) {
      return 'is-valid'
    } else {
      return 'is-invalid'
    }
  } else {
    return false
  }
}

let randomLabel = function (label) {
  let num = label.charCodeAt(0)
  return {
    'label-warning': num % 5 === 0,
    'label-primary': num % 5 === 1,
    'label-danger': num % 5 === 2,
    'label-default': num % 5 === 3,
    'label-info': num % 5 === 4
  }
}

let S3_BUCKET_URL = 'https://budgetvals.s3.amazonaws.com/'

export {
  S3_BUCKET_URL,
  validationClass,
  validationMessage,
  validationIcon,
  randomLabel,
  formControlValidationClass
}



// WEBPACK FOOTER //
// ./src/util/helpers.js